import { RiLoader4Line } from '@remixicon/react';
import type { ReactNode } from 'react';

import { type Size, cn } from '@playbook/utils';

import css from './styles.module.css';

export type SpinnerSize = Extract<Size, 'sm' | 'md' | 'lg' | 'xl'>;

const DefaultSpinnerSize: SpinnerSize = 'md' as const;

interface SpinnerProperties {
	size?: SpinnerSize;
}

/**
 *	Placeholder art: `RiLoader4Line` stands in until the spinner's own SVG
 *	replaces it.
 */
export function Spinner({
	size = DefaultSpinnerSize,
}: SpinnerProperties): ReactNode {
	const className: string = cn(css.spinner, css[size]);

	return (
		<RiLoader4Line
			aria-hidden
			data-spinner
			data-size={size}
			className={className}
		/>
	);
}
